import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import {
  PaginateQuery,
  CreateCityRequest,
  UpdateCityRequest,
} from "../../interfaces";

export const cityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query<any, PaginateQuery>({
      query: (data) => ({ url: buildPaginationQueryString(data, "/api/city") }),
      providesTags: ["Paginated-Cities"],
    }),
    getCity: builder.query<any, string>({
      query: (id) => ({ url: `/api/city/${id}` }),
      providesTags: ["City"],
    }),
    getCitySelectList: builder.query<any, string | void>({
      query: (governorateId) =>
        governorateId
          ? { url: `/api/city/select-list/all?governorateId=${governorateId}` }
          : { url: `/api/city/select-list/all` },
      providesTags: ["Cities-Select-List"],
    }),
    addCity: builder.mutation<any, CreateCityRequest>({
      query: (data) => ({
        url: "/api/city",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["City", "Paginated-Cities", "Cities-Select-List"],
    }),
    updateCity: builder.mutation<any, { id: string; data: UpdateCityRequest }>({
      query: ({ id, data }) => ({
        url: `/api/city/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["City", "Paginated-Cities", "Cities-Select-List"],
    }),
    deleteCity: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/city/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Cities", "Cities-Select-List"],
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useGetCityQuery,
  useGetCitySelectListQuery,
  useAddCityMutation,
  useUpdateCityMutation,
  useDeleteCityMutation,
} = cityApi;
